module.exports = __webpack_public_path__ + "img/1f9b8-1f3fe-200d-2640-fe0f.1e1bb8c.svg";